import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'

Vue.use(Vuex)
import defaultPic from '../assets/defaultPic.jpg'
import defaultHead from '../assets/defaultHead.png'

// 应用初始状态
const state = {
    count: 10,
    common: {
        //root: 'http://192.168.0.200:7788/boss/',//嘉泽
        //root: 'http://boss.china-lace.com/boss/',//海外版
        //root: 'http://192.168.10.44/boss/',//本地测试
        //root: 'http://192.168.10.144:7003/boss/',//祖康
        //root: 'http://192.168.10.205:6699/boss/',//邱凯捷
        root: 'https://h5.boss.360leiliang.com/boss/',//正式外网
        //root: 'http://192.168.11.44:7003/boss/',//测试
        // root: 'http://boss.360leiliang.com/boss/',

        pageCount: 10
    },

    testPath: '', // '/test'
    //本地对应app版本
    //IOS---Android
    //判断用versionCode
    appVersion: {
        ios: {
            /*versionCode: '1.0',
            versionName: '1.0.0'*/
            type: 'ios',
            versionCode: '1.4',//右上角以及下载功能
            versionName: '1.4.0'
        },
        android: {
            type: 'android',
            forceUpdate: true,//强制更新
            log: '',//日志
            versionName: '1.1.1',//版本名
            versionCode: 11,//版本号
            url: 'https://oss.360leiliang.com/apk/1132858421041692672.apk', //新1.1.1
            /*versionName: '1.1.0',//版本名
            versionCode: 10,//版本号
            url: 'http://oss.360leiliang.com/apk/1062972265819275264.apk', //1.0*/
            //https://fir.im/leiliangboss'
            //https://h5.boss.360leiliang.com/App/Stable/Android/leiliangboss.apk
        }
    },
    //统一背景色
    commonBackground: '#E36159',

    //登录地址（域名）
    domain: 'https://h5.boss.360leiliang.com',

    //头部测试参数
    headersTest: '',

    //分页数量
    pageCount: 30,

    defaultPic: defaultPic,
    defaultHead: defaultHead,

    //服务器时间
    serverTime: '',
    picSearchBase64: null,  //str

    //列表的缓存
    list: {
        cache: false,
    },
    //图片搜索状态
    picSearchStatus: {
        base64: false,
        base64Vaule: '',
        top: 0,
        newSearch: true,
        data: [],
        page: 1,
        current: {},
    },
    enum: {
        category: ['全部', '面料', '大边', '小边', '睫毛']
    },
    staticData: false,
    //默认加载中图片
    defaultLoadingPic: '',
    //产品列表页面
    productList: {
        filterList: [],
        index: 0,
        list: [
            {
                top: 0,
                data: [],
                page: 1,
            }
        ],
    },
    //新闻列表
    newsList: null, //arr
    //联系我们
    contactUs: {
        entInfo: null,  //obj
        contactInfo: null //arr
    },
    //首页
    home: null, //obj
    //厂房设备
    deviceList: null, //arr
    //关于我们
    introduction: null, //obj


    //版权
    copyRightText: '',

    //产品
    storeProduct: null, //obj


    authorizationListObj: null, //obj


    //库存报表
    inventoryReport: null,


    //单位换算-------------
    unitConversion: {
        //购买单位
        buy: {
            //'10': '公斤',//kg
            '20': '公斤',//kg
            '30': '码',//yard
            '40': '米',//meter
        },
        //成熟度
        maturity: {
            '1': '坯布',
            '2': '成品',
        },
        //交易通道
        tradeChannel: {
            '1': 'Android APP',
            '2': 'IOS APP',
        },
        //支付状态
        payStatus: {
            '0': '待支付',
            '10': '已部分支付',
            '11': '已支付订金',
            '20': '已付全款',
        },
        //发货状态
        deliveryStatus: {
            '0': '待发货',
            '10': '已发样品',
            '20': '已发货',
        },
        //购买方式
        tradeWay: {
            '1': '普通',
        },
        //完成状态
        finishStatus: {
            '0': '未完成',
            '10': '部分完成',
            '20': '已完成',
        },
        //订金支付方式
        depositPayWay: {
            '10': '网银',
            '20': '支付宝',
            '30': '微信',
            '40': '线下',
        },
        //支付方式
        payWay: {
            '10': '网银',
            '20': '支付宝',
            '30': '微信',
            '40': '线下',
        },

        //退货状态
        returnGoodsStatus: {
            '-20': '未通过',
            '-10': '已取消',
            '0': '待审核',
            '10': '通过',
            '20': '已退货',
        },
        //退款类型
        refundType: {
            '10': '退货并退款',
            '20': '仅退款',
        },
        //退款状态
        refundStatus: {
            '-20': '未通过',
            '-10': '已取消',
            '0': '待审核',
            '10': '通过',
            '20': '已退款',
        }
    },
}

//修改域名
if(state.common.root != 'http://h5.boss.360leiliang.com/boss/' && state.common.root != 'https://h5.boss.360leiliang.com/boss/'){
    state.headersTest = '10025';
    //state.domain = 'http://192.168.0.144';
}

// 定义所需的 mutations
const mutations = {
    INCREMENT (state) {
        state.count++
    },
    DECREMENT (state) {
        state.count--
    },

    // 开始


    // 结束




    setServerTime(state, str){
        state.serverTime = str
    },
    setCategory(state, str){
        state.enum.category = str
    },
    setPicSearchBase64(state, str){
        state.picSearchBase64 = str
    },
    //图片搜索状态
    setPicSearchStatus(state, obj){
        state.picSearchStatus = {
            base64: obj.base64 || false,
            base64Value: obj.base64Value || '',
            top: obj.top || 0,
            data: obj.data || [],
            page: obj.page,
            newSearch: obj.newSearch,
            current: obj.current,
        }
        if (typeof obj.newSearch == 'undefined') {
            state.picSearchStatus.newSearch = true;
        }
    },
    setNewSearch(state, boolean){
        state.picSearchStatus.newSearch = boolean;
    },
    setProductList(state, obj){
        state.productList.filterList = obj.filterList;
        state.productList.index = obj.index;
        state.productList.list = obj.list;
        //state.productList.list[obj.index].top = obj.top;
        //state.productList.list[obj.index].data = obj.data;
    },
    //新闻列表
    setNewsList(state, arr){
        state.newsList = arr
    },
    //联系我们
    setEntInfo(state, arr){
        state.contactUs.entInfo = arr
    },
    setContactInfo(state, obj){
        state.contactUs.contactInfo = obj
    },
    //首页
    setHome(state, obj){
        state.home = obj
    },
    //厂房设备列表
    setDeviceList(state, arr){
        state.deviceList = arr
    },
    //关于我们
    setIntroduction(state, obj){
        state.introduction = obj
    },
    //修改默认的
    setDefaultLoadingPic(state, str){
        state.defaultLoadingPic = str
    },


    //修改版权
    setCopyRightText(state, string){
        state.copyRightText = string
    },

    //修改产品列表
    setStoreProduct(state, obj){
        state.storeProduct = obj
    },


    //缓存
    setAuthorizationListObj(state, obj){
        state.authorizationListObj = obj
    },


    //库存报表
    setInventoryReportList(state, obj){
        state.inventoryReport = obj
    }
}

// 创建 store 实例
export default new Vuex.Store({
    actions,
    getters,
    state,
    mutations
})



// WEBPACK FOOTER //
// ./src/vuex/store.js